// Nonsense card game data with rankings
export const NONSENSE_CARDS = [
  { id: 1, name: "42",
    image: "/images/nonsense/nonsense_1.jpg", rank: 1 },
  { id: 2, name: "3,415",
    image: "/images/nonsense/nonsense_2.jpg", rank: 2 },
  { id: 3, name: "8",
    image: "/images/nonsense/nonsense_3.jpg", rank: 3 },
  { id: 4, name: "19",
    image: "/images/nonsense/nonsense_4.jpg", rank: 4 },
  { id: 5, name: "1",
    image: "/images/nonsense/nonsense_5.jpg", rank: 5 },
  { id: 6, name: "12,133",
    image: "/images/nonsense/nonsense_6.jpg", rank: 6 },
  { id: 7, name: "44",
    image: "/images/nonsense/nonsense_7.jpg", rank: 7 },
  { id: 8, name: "2",
    image: "/images/nonsense/nonsense_8.jpg", rank: 8 },
  { id: 9, name: "99",
    image: "/images/nonsense/nonsense_9.jpg", rank: 9 },
  { id: 10, name: "11",
    image: "/images/nonsense/nonsense_10.jpg", rank: 10 },
  { id: 11, name: "12",
    image: "/images/nonsense/nonsense_11.jpg", rank: 11 },
  { id: 12, name: "54,654",
    image: "/images/nonsense/nonsense_12.jpg", rank: 12 },
  { id: 13, name: "13",
    image: "/images/nonsense/nonsense_13.jpg", rank: 13 },
  { id: 14, name: "55",
    image: "/images/nonsense/nonsense_14.jpg", rank: 14 },
  { id: 15, name: "652",
    image: "/images/nonsense/nonsense_15.jpg", rank: 15 },
  { id: 16, name: "4",
    image: "/images/nonsense/nonsense_16.jpg", rank: 16 },
  { id: 17, name: "1,996",
    image: "/images/nonsense/nonsense_17.jpg", rank: 17 },
  { id: 18, name: "2,101",
    image: "/images/nonsense/nonsense_18.jpg", rank: 18 },
  { id: 19, name: "33",
    image: "/images/nonsense/nonsense_19.jpg", rank: 19 },
  { id: 20, name: "7",
    image: "/images/nonsense/nonsense_20.jpg", rank: 20 },
  { id: 21, name: "45",
    image: "/images/nonsense/nonsense_21.jpg", rank: 21 },
  { id: 22, name: "88",
    image: "/images/nonsense/nonsense_22.jpg", rank: 22 },
  { id: 23, name: "420",
    image: "/images/nonsense/nonsense_23.jpg", rank: 23 },
  { id: 24, name: "Hey",
    image: "/images/nonsense/nonsense_24.jpg", rank: 24 },
  { id: 25, name: "612",
    image: "/images/nonsense/nonsense_25.jpg", rank: 25 },
  { id: 26, name: "126",
    image: "/images/nonsense/nonsense_26.jpg", rank: 26 },
  { id: 27, name: "678",
    image: "/images/nonsense/nonsense_27.jpg", rank: 27 },
  { id: 28, name: "26",
    image: "/images/nonsense/nonsense_28.jpg", rank: 28 },
  { id: 29, name: "29",
    image: "/images/nonsense/nonsense_29.jpg", rank: 29 },
  { id: 30, name: "5",
    image: "/images/nonsense/nonsense_30.jpg", rank: 30 }
];
